import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchHomeBanner: null,
  fetchHomeBannerStart: null,
  fetchHomeBannerSuccess: ['bannerData'],
  fetchHomeBannerFailure: null,

  fetchLatest: ['pageNumber'],
  fetchLatestStart: null,
  fetchLatestSuccess: ['latest'],
  fetchLatestFailure: null,

  fetchTrending: null,
  fetchTrendingStart: null,
  fetchTrendingSuccess: ['trending'],
  fetchTrendingFailure: null,

  fetchReviews: null,
  fetchReviewsStart: null,
  fetchReviewsSuccess: ['reviews'],
  fetchReviewsFailure: null
});

export { Types, Creators };
